// extracted by mini-css-extract-plugin
export var menuIcon = "_k5-0";
export var menuIconInline = "_k5-1";